import { useRouter } from 'next/router';

import { ChatPanelHelper } from './helpers/chat-panel-helper';
import type { ChatPanelSurface } from './types/types';

/** Which page family the panel is attached to, for the surface-specific empty state. */
export const useChatPanelSurface = (): ChatPanelSurface | null => {
  const { pathname } = useRouter();

  return ChatPanelHelper.getSurface(pathname);
};
